import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName } from '../utils';

/** 契約状態区分のENUM */
enum ContractConditionClass {
  /** 契約中 */
  underContract = '1',
  /** 物件中途解約済 */
  articleCanceledBefMaturity = '2',
  /** 契約中途解約済 */
  contractCanceledBefMaturity = '3',
  /** 再リース済 */
  reLeased = '4',
  /** 満了済 */
  expired = '5',
  /** 再リース締結済 */
  reLeaseContractCanceled = '6',
  /** 再リース予定 */
  scheduledReLease = '7',
}

const nameConfig = {
  underContract: new Map([[Locale.ja, '契約中']]),
  articleCanceledBefMaturity: new Map([[Locale.ja, '物件中途解約済']]),
  contractCanceledBefMaturity: new Map([[Locale.ja, '契約中途解約済']]),
  reLeased: new Map([[Locale.ja, '再リース済']]),
  expired: new Map([[Locale.ja, '満了済']]),
  reLeaseContractCanceled: new Map([[Locale.ja, '再リース締結済']]),
  scheduledReLease: new Map([[Locale.ja, '再リース予定']]),
};

const toDisplay = enumToName(ContractConditionClass, nameConfig);
const toDisplayWithPrefix = enumToName(ContractConditionClass, nameConfig, { prefix: true });

export const contractConditionClass = {
  enum: ContractConditionClass,
  nameConfig,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ContractConditionClass };
